export default __webpack_public_path__ + "static/media/django2.972e3a45.svg";